import { Box, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { ButtonCompo } from "../components/Comman/Button";
import { LabelCompo } from "../components/Comman/Label";
import { redColor, titleColor } from "../config/ColorObj";

const LocationRow = ({
    id,
    showLocation,
    locationValue,
    latitude,
    longitude,
    address,
    onChangeLocation,
    onRadioChange,
    onSaveLocation,
    addressTitle = "Address",
}) => {
    return (
        <>
            <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ mb: -0.3, mt: 1 }}
            >
                {/* Change Location Button — no label column needed */}
                {id !== undefined && !showLocation && (
                    <Grid item xs={12}>
                        <ButtonCompo
                            size="medium"
                            type="submit"
                            variant="contained"
                            name="Change Location"
                            onClick={onChangeLocation}
                        />
                    </Grid>
                )}

                {showLocation && (
                    <>
                        {/* Label column */}
                        <Grid item xs={12} sm={2} display="flex" alignItems="center">
                            <Box sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: redColor }}
                                    label="*"
                                />
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: titleColor }}
                                    label="Location :"
                                />
                            </Box>
                        </Grid>

                        {/* Content column — radio + get location button + lat/lng */}
                        <Grid
                            item
                            xs={12}
                            sm={10}
                            display="flex"
                            alignItems="center"
                            flexWrap="wrap"
                            gap={1}
                        >
                            <RadioGroup
                                row
                                aria-label="Location"
                                name="Location"
                                id="Location"
                                value={locationValue}
                                onChange={onRadioChange}
                                size="small"
                            >
                                <FormControlLabel value="1" control={<Radio />} label="Current" />
                                <FormControlLabel value="0" control={<Radio />} label="From Map" />
                            </RadioGroup>

                            {locationValue && locationValue == 0 && (
                                <ButtonCompo
                                    size="small"
                                    type="submit"
                                    variant="contained"
                                    name="Get Location"
                                    onClick={onSaveLocation}
                                />
                            )}

                            {latitude !== "" && longitude !== "" && (
                                <Grid display="flex" alignItems="center" gap={0.5}>
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: titleColor }}
                                        label="Latitude - Longitude :"
                                    />
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16 }}
                                        label={`${latitude}, ${longitude}`}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </>
                )}
            </Grid>

            {/* Address Row — same structure as Location row, with gap on top */}
            <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ mt: 1 }}
            >
                {/* Label column — same ml:2 offset as *Location */}
                <Grid item xs={12} sm={2} display="flex" alignItems="center">
                    <Box sx={{ ml: 2, display: "flex", alignItems: "center" }}>
                        <LabelCompo
                            className="text-black"
                            style={{ fontSize: 16, color: redColor }}
                            label="*"
                        />
                        <LabelCompo
                            className="text-black"
                            style={{ fontSize: 16, color: titleColor }}
                            label={`${addressTitle} :`}
                        />
                    </Box>
                </Grid>

                {/* Content column — same sm={10} as Location row */}
                <Grid
                    item
                    xs={12}
                    sm={10}
                    display="flex"
                    alignItems="center"
                >
                    <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16 }}
                        label={address || "-"}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default LocationRow;